export default {
  FETCH_TARGET_MAPPING_INFORMATION_SUCCESS: 'FETCH_TARGET_MAPPING_INFORMATION_SUCCESS',
  BACKUP_TARGET_FIELDS: 'BACKUP_TARGET_FIELDS',
  RESTORE_TARGET_FIELDS: 'RESTORE_TARGET_FIELDS',
  FETCH_TARGET_FIELDS_SCHEMAS_SUCCESS: 'FETCH_TARGET_FIELDS_SCHEMAS_SUCCESS',
  FETCHING_TARGET_FIELDS: 'FETCHING_TARGET_FIELDS',
  DISABLE_MAPPED_TARGET_FIELDS: 'DISABLE_MAPPED_TARGET_FIELDS',
  ENABLE_MAPPED_TARGET_FIELDS: 'ENABLE_MAPPED_TARGET_FIELDS'
};



// WEBPACK FOOTER //
// ./src/redux/targetFields/TargetFieldsConstants.js